import React from "react";
import { DayPicker } from "./day_picker";
import { Interval } from "date-fns";

export interface DateRangePickerProps {
  testID?: string;
  value?: Interval;
  onChange?: (value: Interval) => void;
  isOutsideRange?: (date: Date) => boolean;
  isBlocked?: (date: Date) => boolean;
  numberOfMonths?: number;
  orientation?: "vertical" | "horizontal";
  allowBypassBlockedDates?: boolean;
}

export function DateRangePicker(props: DateRangePickerProps) {
  const {
    value,
    onChange = () => {},
    testID,
    isOutsideRange,
    isBlocked,
    numberOfMonths,
    orientation,
    allowBypassBlockedDates,
  } = props;

  return (
    <div data-component="DateRangePicker" data-testid={testID}>
      <DayPicker
        isRange
        value={value}
        onChange={onChange}
        isBlocked={isBlocked}
        isOutsideRange={isOutsideRange}
        numberOfMonths={numberOfMonths}
        orientation={orientation}
        allowBypassBlockedDates={allowBypassBlockedDates}
      />
    </div>
  );
}
